import * as React from 'react'
import Svg from '../Svg'
export const SvgArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        viewBox="0 0 60 85"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M33.9 1.7C32.8.6 31.5 0 30 0s-2.8.6-3.9 1.7L1.7 26.3C.6 27.4 0 28.7 0 30.2s.6 2.8 1.7 3.9 2.3 1.6 3.9 1.6 2.8-.5 3.9-1.6l15.1-15.2v60.6c0 1.5.6 2.8 1.7 3.9.9 1.1 2.2 1.6 3.7 1.6s2.8-.5 3.9-1.6 1.6-2.4 1.6-3.9V19l15.1 15.1c1.1 1.1 2.3 1.6 3.9 1.6s2.8-.5 3.9-1.6 1.6-2.4 1.6-3.9-.5-2.8-1.6-3.9L33.9 1.7z" />
    </Svg>
)
SvgArrowUp.isIcon = true
export default SvgArrowUp
